import React, { useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Typography } from '@material-ui/core'
import styled from 'styled-components'
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { useQuery } from '@apollo/react-hooks'
import { coursesQueries } from '../../graphql/queries'
import CancelIcon from '@material-ui/icons/Cancel';

const useStyles = makeStyles({
  root: {
    '&:hover': {
      backgroundColor: 'transparent'
    }
  },
  enunciado: {
    color: '#4E4D4D',
    fontSize: '18px'
  },
  resposta: {
    color: '#4E4D4D',
    fontSize: '16px',
    marginLeft: 10,
    backgroundColor: '#EAEAEA',
    width: '98%',
    paddingLeft: 5,
    paddingRight: 5,
    '@media(max-width: 1050px)': {
      width: '90%'
    }
  },
  comentario: {
    color: '#4E4D4D',
    fontSize: '16px',
    marginLeft: 10,
    width: '98%',
    paddingLeft: 5,
    paddingRight: 5,
    fontStyle: 'italic',
    fontWeight: 300,
    '@media(max-width: 1050px)': {
      width: '90%'
    }
  }
})

const QuestionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 40px 0;
`

const QuestionBox = styled.div`
  display: flex;
  flex-direction: column;
  margin: 20px 0;
  width: 100%;
`
const AnswersBox = styled.div`
  display: flex;
  align-items: flex-start;
  margin: 10px 0;
  width: 100%;
  border:  ${({ isSelected }) => (!!isSelected ? '3px solid rgba(19,124,189,.6)' : 'none')};
  border-radius: ${({ isSelected }) => (!!isSelected ? '10px' : 'none')};
  padding: ${({ isSelected }) => (!!isSelected ? '5px' : 'none')};
`

const AnswersContent = styled.div`
  margin-bottom: 10px;
  width: 100%;
`

const AllQuizResults = ({ finalAnswers, questions, content }) => {

  const { data, refetch } = useQuery(coursesQueries.GET_ALL_QUIZ_ANSWERS, {
    variables: { conteudo_id: content }
  })

  const classes = useStyles()
  const questoes = questions || []
  const allQuizAnswers = data?.todasRespostasQuiz || []

  useEffect(() => {
    refetch()
    window.MathJax.typeset()
  })

  return (
    <QuestionsWrapper>
      {questoes.map((quest, questKey) => {

        const questEnunciado = quest?.enunciado
        const questRespostas = quest?.respostas || []
        const questNumber = questKey + 1

        return (
          <QuestionBox>
            <Typography gutterBottom variant="h6" component="h2" className={classes.enunciado}>
              <div dangerouslySetInnerHTML={{
                __html: `Pergunta ${questNumber} - ${(questEnunciado || '').replace(/<math>|<\/math>/gi, '`')}`
              }} />
            </Typography>
              {questRespostas.map((resp) => {

                  const respId = resp?._id
                  const restResposta = resp?.resposta

                  const comentario = allQuizAnswers.map(quizArray => {
                    const currentAnswer = quizArray.find(answ => answ._id === respId)
                    return ((currentAnswer) ? currentAnswer.comentario : false)
                  }).find(e => e !== false)

                  const isCorrect = allQuizAnswers.map(quizArray => {
                    const currentAnswer = quizArray.find(answ => answ._id === respId)
                    return ((currentAnswer) ? currentAnswer.certa : false)
                  }).find(e => e !== false)

                  const isSelected = finalAnswers.find(respond => respond?.selectedAnswer === respId)
                  
                return (
                  <AnswersBox isSelected={(isSelected) ? true : false}>
                    {(isCorrect ? <CheckCircleIcon style={{ color: 'green' }}/> :
                    <CancelIcon style={{ color: 'red' }}/> )}
                    <AnswersContent>
                      <Typography gutterBottom variant="h6" component="h2" className={classes.resposta}>
                        <div dangerouslySetInnerHTML={{
                          __html: `${(restResposta || '').replace(/<math>|<\/math>/gi, '`')}`
                        }} />
                      </Typography>
                      <Typography gutterBottom variant="h6" component="h2" className={classes.comentario}>
                        <div dangerouslySetInnerHTML={{
                          __html: `${(comentario || '').replace(/<math>|<\/math>/gi, '`')}`
                        }} />
                      </Typography>
                    </AnswersContent>
                  </AnswersBox>
                )})}
          </QuestionBox>
        )})}
    </QuestionsWrapper>
  )
  
}

export default AllQuizResults
